export interface Translations {
    // Landing Page
    selectLanguage: string;
    selectWordPack: string;
    startNewGame: string;

    // Game Controls
    backToMenu: string;
    endTurn: string;
    undoMove: string;
    revealBoard: string;
    hideBoard: string;
    redTeam: string;
    blueTeam: string;
    spymasterView: string;

    // Game Status
    redTeamTurn: string;
    blueTeamTurn: string;
    spymasterPhase: string;
    guessingPhase: string;
    gameOver: string;
    redTeamWins: string;
    blueTeamWins: string;
    giveClue: string;
    guessesRemaining: string;

    // Game Board
    newGame: string;
    generateNew: string;
    spymaster: string;

    // GameLinkPage
    shareGameLink: string;
    copyLink: string;
    linkCopied: string;
    playGame: string;

    // Clue input
    clue: string;
    count: string;

    // Timer
    timeRemaining: string;

    // General
    loading: string;
    error: string;
}

export const englishTranslations: Translations = {
    // Landing Page
    selectLanguage: 'UI Language:',
    selectWordPack: 'Word Pack:',
    startNewGame: 'Start New Game',

    // Game Controls
    backToMenu: '← Back to Menu',
    endTurn: 'End Turn',
    undoMove: 'Undo',
    revealBoard: 'Reveal Board',
    hideBoard: 'Hide Board',
    redTeam: 'Red Team',
    blueTeam: 'Blue Team',
    spymasterView: 'Spymaster View',

    // Game Status
    redTeamTurn: 'Red Team\'s Turn',
    blueTeamTurn: 'Blue Team\'s Turn',
    spymasterPhase: 'Spymaster Phase',
    guessingPhase: 'Guessing Phase',
    gameOver: 'Game Over',
    redTeamWins: 'Red Team Wins!',
    blueTeamWins: 'Blue Team Wins!',
    giveClue: 'Give Clue',
    guessesRemaining: 'guesses remaining',

    // Game Board
    newGame: 'New Game',
    generateNew: 'Generate New',
    spymaster: 'Spymaster',

    // GameLinkPage
    shareGameLink: 'Share Game Link',
    copyLink: 'Copy Link',
    linkCopied: 'Link Copied!',
    playGame: 'Play Game',

    // Clue input
    clue: 'Clue',
    count: 'Count',

    // Timer
    timeRemaining: 'Time Remaining',

    // General
    loading: 'Loading...',
    error: 'Error'
};

export const arabicTranslations: Translations = {
    // Landing Page
    selectLanguage: 'لغة الواجهة:',
    selectWordPack: 'مجموعة الكلمات:',
    startNewGame: 'ابدأ لعبة جديدة',

    // Game Controls
    backToMenu: '← العودة للقائمة',
    endTurn: 'إنهاء الدور',
    undoMove: 'تراجع',
    revealBoard: 'كشف اللوحة',
    hideBoard: 'إخفاء اللوحة',
    redTeam: 'الفريق الأحمر',
    blueTeam: 'الفريق الأزرق',
    spymasterView: 'عرض قائد الجواسيس',

    // Game Status
    redTeamTurn: 'دور الفريق الأحمر',
    blueTeamTurn: 'دور الفريق الأزرق',
    spymasterPhase: 'مرحلة قائد الجواسيس',
    guessingPhase: 'مرحلة التخمين',
    gameOver: 'انتهت اللعبة',
    redTeamWins: 'الفريق الأحمر يفوز!',
    blueTeamWins: 'الفريق الأزرق يفوز!',
    giveClue: 'أعط تلميحاً',
    guessesRemaining: 'تخمينات متبقية',

    // Game Board
    newGame: 'لعبة جديدة',
    generateNew: 'توليد جديد',
    spymaster: 'قائد الجواسيس',

    // GameLinkPage
    shareGameLink: 'شارك رابط اللعبة',
    copyLink: 'نسخ الرابط',
    linkCopied: 'تم نسخ الرابط!',
    playGame: 'العب اللعبة',

    // Clue input
    clue: 'التلميح',
    count: 'العدد',

    // Timer
    timeRemaining: 'الوقت المتبقي',
    // General
    loading: 'جاري التحميل...',
    error: 'خطأ'
};
